// * Create by jiangjijing on 2020/3/2
// 引入axios以及element ui中的loading和message组件
import axios from 'axios'
import { myToast } from '../components/myToast.js'
// 自动配置环境
axios.defaults.baseURL = process.env.BASE_API

// 超时时间
axios.defaults.timeout = 60000
// http请求拦截器
axios.interceptors.request.use(config => {
  return config
}, (error) => {
  return Promise.reject(error)
})
// http响应拦截器
axios.interceptors.response.use(data => { // 响应成功关闭loading
  return data
}, error => {
  setTimeout(function () {
    myToast({
      type: 'error',
      message: '加载失败',
      duration: 2000
    })
  }, 2000)
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/config/axios.js